import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js';
import std from './students.js';
import inc from './income.js';
const url = gapi + "withdraws";


const outcome = {
  namespaced: true,
  state: {
    msg:null,
    withdrawAll: [],
    students:[],
    emp:[],
    accountType:[],
    payType:[]  
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.withdrawAll;
    },
    getTodoById: (state) => (id) => {
      return state.withdrawAll.find((todo) => todo.id == id);
    },
    getEmpSub: (state) => (id) => {
      var total = 0;
      var paid = 0;
      var cred = 0;
      var prec = 0;
      var em = str.state.emps.find((todo) => todo.id == id);
      var pid = inc.state.payAll.filter((todo) => todo.busID == em.bus_id);
      var stt = std.state.stdAll.filter((todo) => todo.busCode == em.bus_id);
      var cre = state.withdrawAll.filter((todo) => todo.empID == id);

     if(stt != null){
      stt.forEach((item) =>{total +=parseFloat(item.AmountSub); } );}
      if(pid != null){
        pid.forEach((item) =>{paid += parseFloat(item.amount); } );
        prec = parseFloat((paid * em.percentage)/100);
      }
      if(cre != null){
        cre.forEach((item) =>{cred += parseFloat(item.creditor); } );}

        var empSub={
          subCount:stt.length,
          subTotal:total,
          subPaid:paid,
          subSalary:em.Salary,
          subDeptor:cred,
          subCreditor:prec,
      }
      return empSub;
    },getStdSub: (state) => (id) => {
      var dept = 0;
      var cred = 0;
      
      var pid = inc.state.payAll.filter((todo) => todo.stdID == id);
      var stt = std.state.stdAll.find((todo) => todo.id == id);
    
      if(pid != null){
        pid.forEach((item) =>{cred += parseFloat(item.amount); } );
      }
      if(stt != null){
        dept = stt.AmountSub;
      }
         
        var empSub={
          stdDeptor:dept,
          stdCreditor:cred
      }
      return state.msg,empSub;
    },
    getMsg: (state) => {
      return state.msg;
    }
  },
  mutations: {
    SET_DATA(state, data) {
      state.withdrawAll = data;
    },

    ADD_DATA(state, data) {
      var stdf = null;
      var empf = null;

      if(data.stdID != null){
        this.students = std.state.stdAll.find((todo) => todo.id == data.stdID);
        stdf = this.students.Fname + ' '+this.students.Ffname
      }
      if(data.empID != null){
        this.emp = str.state.emps.find((todo) => todo.id == data.empID);
         empf = this.emp.Fname + ' '+this.emp.Ffname
      }
      this.accountName = str.state.accountType.find((todo) => todo.id == data.accType);
      var boxes = str.state.boxes.find((todo) => todo.id == data.FromAccount);
      this.payType = str.state.payType.find((todo) => todo.id == data.withdrawType);
     
      var dts = {
        id: data.id,
        withdrawDate: data.withdrawDate,
        accType: data.accType,
        Details: data.Details,
        withdrawType: data.withdrawType,
        FromAccount: data.FromAccount,
        check: data.check,
        deptor: data.deptor,
        creditor: data.creditor,
        accountName: this.accountName.accountName,
        ToAccountName: boxes.accountName,
        pType: this.payType.pType,
        stdID: data.stdID,
        empID: data.empID,
        stdFN : stdf,
        empFN : empf
              
                     }
      state.withdrawAll.unshift(dts);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.withdrawAll.findIndex((t) => t.id === data.id);
      var stdf = null;
      var empf = null;

      if(data.stdID != null){
        this.students = std.state.stdAll.find((todo) => todo.id == data.stdID);
        stdf = this.students.Fname + ' '+this.students.Ffname
      }
      if(data.empID != null){
        this.emp = str.state.emps.find((todo) => todo.id == data.empID);
         empf = this.emp.Fname + ' '+this.emp.Ffname
      }
      this.accountName = str.state.accountType.find((todo) => todo.id == data.accType);
      var boxes = str.state.boxes.find((todo) => todo.id == data.FromAccount);
      this.payType = str.state.payType.find((todo) => todo.id == data.withdrawType);
     
      var dts = {
        id: data.id,
        withdrawDate: data.withdrawDate,
        accType: data.accType,
        Details: data.Details,
        withdrawType: data.withdrawType,
        FromAccount: data.FromAccount,
        check: data.check,
        deptor: data.deptor,
        creditor: data.creditor,
        accountName: this.accountName.accountName,
        ToAccountName: boxes.accountName,
        pType: this.payType.pType,
        stdID: data.stdID,
        empID: data.empID,
        stdFN : stdf,
        empFN : empf
              
                     }
      if (index !== -1) {
        state.withdrawAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.withdrawAll = state.withdrawAll.filter((t) => data.id !== t.id);
    },STATE_CRUD(state,data){
      var num = data;
      num = num.toString().replace( /^\D+/g, '');
      state.msg = num;
    }
  }
  ,
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
          return res
        })
        .catch((error) => {
        console.log(error)
        return error
      });
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
   async  updateData({ commit }, data) {

      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then((res)=>{
         
          commit("UPDATE_DATA", data)
          commit("STATE_CRUD", res.data.status)
        
        })
        .catch((error) =>{ console.log(error)
         
         
          commit("STATE_CRUD", error)
      });
    
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default outcome;
